import React from "react";

const DashboardSkeleton = () => {
  // We simulate a few categories and items to fill the screen
  const skeletonCategories = [
    { section: "Loading...", items: [1, 2] },
    { section: "Loading...", items: [1, 2, 3, 4, 5] },
    { section: "Loading...", items: [1, 2] },
  ];

  return (
    <div className="min-h-screen w-full bg-gray-50 pb-20 md:pb-24 animate-pulse">
      {/* Header Skeleton */}
      <div className="sticky top-0 z-40 bg-white border-b border-gray-100 px-4 py-4 md:px-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="h-10 w-10 md:h-12 md:w-12 rounded-xl bg-gray-200"></div>
            <div>
              <div className="h-5 w-32 bg-gray-200 rounded mb-2"></div>
              <div className="h-3 w-20 bg-gray-100 rounded"></div>
            </div>
          </div>
          <div className="h-10 w-10 rounded-full bg-gray-200"></div>
        </div>
      </div>

      {/* Grid Skeleton */}
      <div className="px-3 md:px-4 lg:px-6 mt-4 md:mt-6 space-y-6 md:space-y-8">
        {skeletonCategories.map((cat, idx) => (
          <div key={idx} className="space-y-3 md:space-y-4">
            <div className="h-4 w-24 bg-gray-200 rounded ml-1 md:ml-2"></div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-3 md:gap-4">
              {cat.items.map((_, i) => (
                <div key={i} className="flex flex-col items-center justify-center p-3 md:p-4 rounded-2xl bg-white border border-gray-100 shadow-sm">
                  <div className="p-3 md:p-3 rounded-xl bg-gray-200 w-12 h-12 mb-2 md:mb-3"></div>
                  <div className="h-3 w-12 bg-gray-200 rounded mb-1.5"></div>
                  <div className="h-2 w-16 bg-gray-100 rounded"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardSkeleton;